module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To the United States Navy, Marines, Air Force, and Army; for the assistance in the writing of this novel, you have my deepest thanks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To the United States Geological Service and the help that was given on theory and science. The assistance rendered was far beyond anything and I am grateful.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For Pete Wolverton, who always reminds me I can be better than the first draft (and sometimes better than even the second).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f4bc770","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknow.vue
// module id = 72
// module chunks = 0